<template>
  <v-container
    id="clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <div>
      <v-row>
        <v-col
          cols="12"
          class="container"
        >
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <dashboard-filtros
                :vendedores="enableVendedores"
                :redes="enableRedes"
                :meses="enableMeses"
                :anos="enableAnos"
                :supervisores="enableSupervisores"
                :btn2="enableBtn"
              />
            </v-col>
          </v-row>
          <v-row id="analiseVendasFiltrosId">
            <v-col
              cols="12"
              sm="2"
              md="2"
              lg="2"
            >
              <v-row v-if="enableBtnPrint">
                <v-btn
                  id="btnPrint"
                  class="col-12 col-sm-12 col-md-12 col-lg-12"
                  small
                  :color="corPrimaria"
                  dark
                  :loading="imprimindo"
                  @click="imprimir()"
                >
                  <v-icon>
                    mdi-printer
                  </v-icon>
                  Imprimir
                  <template v-slot:loader>
                    <span>Imprimindo...</span>
                  </template>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-row id="bloco1Print">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Faturamento - R$
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('305')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <show-analise-faturamento-vendedor />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'307'"
                :text="'Preço Médio por Classificação - R$'"
                :texto-information="textoPrecoMVendedor"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartFaturamentoMetaVendedorClassificacao'"
                :dados-grafico="chartFaturamentoMetaVendedorClassificacao"
                :titulo-id="'myChartFaturamentoMetaVendedorClassificacao'"
                :legenda-grafico="coresMetaVendedorClassificacao"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseVendedor2"
                :loading="loadingMetaVendedor"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'307'"
                :text="'Preço Médio por Classificação - R$'"
                :texto-information="textoPrecoMVendedor"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartFaturamentoPrecoMedioClassificacaoVendedores'"
                :dados-grafico="chartFaturamentoPrecoMedioClassificacaoVendedores"
                :titulo-id="'myChartFaturamentoPrecoMedioClassificacaoVendedores'"
                :legenda-grafico="coresPrecoMedioClassificacaoVendedores"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseVendedor3"
                :loading="loadingPrecoMedioVendedor"
              />
            </v-col>
          </v-row>
          <v-row id="bloco2Print">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <dashoard-card-view
                    :exibir-texto-titulo="true"
                    :code-information="'100'"
                    :text="'KG Total Faturamento'"
                    :texto-information="textoKgTotalFat"
                    :style-object="styleObjectDevolucao"
                    :componente-valor="true"
                    :valor="valorKgFaturamento"
                    :padding="dynamicPaddingAnaliseVendedor4"
                    :loading="loadingKgFaturamento"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                >
                  <v-card
                    id="cardDashbord"
                    class="mx-auto"
                    outlined
                  >
                    <div class="card-header-dashbord">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="10"
                          md="10"
                          lg="10"
                          class="d-flex flex-wrap"
                        >
                          Devolução Imprópria - R$
                        </v-col>
                        <v-col
                          cols="12"
                          sm="2"
                          md="2"
                          lg="2"
                          class="d-flex justify-end"
                        >
                          <v-tooltip
                            top
                            max-width="400"
                            width="400"
                          >
                            <template
                              v-slot:activator="{ on, attrs }"
                            >
                              <v-icon
                                id="iconInformationClientesParcipantes"
                                class="text-left"
                                v-bind="attrs"
                                v-on="on"
                                @mouseover="enableTexto('309')"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <div
                              v-if="!carregandoTooltip"
                              v-html="textoOrientacao"
                            />
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </div>
                    <v-card-actions>
                      <v-row>
                        <v-col
                          id="componenteDevolucaoImpropriaVendedor"
                          cols="12"
                          sm="12"
                          md="12"
                          lg="12"
                        >
                          <show-grafico-faturamento-devolucao-impropria-vendedor />
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="6"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'310'"
                :text="'Devoluções x Orçado por Classificação - R$'"
                :texto-information="textoDevolucaoOrcadoVendedor"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartDevolucaoxOrcadoVendedores'"
                :dados-grafico="myChart"
                :titulo-id="'myChartDevolucaoxOrcadoVendedores'"
                :legenda-grafico="coresDevolucaoxOrcadoVendedores"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseVendedor2"
                :loading="loadingDevolucaoOrcadoVendedor"
              />
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="3"
            >
              <dashoard-card-view
                :exibir-texto-titulo="true"
                :code-information="'311'"
                :text="'KG Total por Classificação'"
                :texto-information="textoKgTotalVendedor"
                :style-object="styleObject"
                :componente-grafico="true"
                :grafico-id="'myChartKgTotalClassificacaoVendedor'"
                :dados-grafico="myChart2"
                :titulo-id="'myChartKgTotalClassificacaoVendedor'"
                :exibir-legenda="true"
                :padding="dynamicPaddingAnaliseVendedor3"
                :loading="loadingKgTotalVendedor"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row><br>

      <dashboard-core-snackbar
        v-model="snackbar.visible"
        :visible="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :message="snackbar.message"
      />
    </div>
  </v-container>
</template>

<script>
  import Permissao from '../../../../services/menu'
  import Comercial from '../../../../services/comercialpersonalizacao'
  import eventEmit from '../../components/core/EventoEmit'
  import Chart from 'chart.js'
  import ChartDataLabels from 'chartjs-plugin-datalabels'
  import html2canvas from 'html2canvas'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardAnaliseEquipeVendas',
    emits: ['setUpdateFiltros', 'enableFaturamento', 'disableLoading', 'disableLoadingGrafico', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltros: () => import('../../components/core/FiltrosSaborDaSerra'),
      ShowAnaliseFaturamentoVendedor: () => import('../../graficos/ComercialPersonalizado/AnaliseFaturamentoVendedor'),
      ShowGraficoFaturamentoDevolucaoImpropriaVendedor: () => import('../../graficos/ComercialPersonalizado/FaturamentoDevolucaoImpropriaVendedor'),
      DashoardCardView: () => import('../../components/core/CardView'),
    },

    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleTexto: {
        color: '#00796B',
      },
      styleObjectDevolucao: {
        color: '#E53935',
      },
      paginaEnable: false,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      redes: [],
      ano: [],
      mes: [],
      vendedor: [],
      supervisores: [],
      permissaoAnaliseFaturamento: false,
      enableVendedores: true,
      enableRedes: true,
      enableMeses: true,
      enableAnos: true,
      enableBtn: true,
      enableSupervisores: true,
      enableBtnPrint: false,
      codigo: 0,
      orientacao: [],
      textoFatVendedor: '',
      textoFaturamentoMetaVendedor: '',
      textoPrecoMVendedor: '',
      textoKgTotalFat: '',
      textoDevImpropria: '',
      textoDevolucaoOrcadoVendedor: '',
      textoKgTotalVendedor: '',
      codigoIds: ['305', '306', '307', '308', '309', '310', '311'],
      montarGrafico: true,
      loading: false,
      error: null,
      loading2: false,
      error2: null,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      myChart: {},
      myChart2: {},
      cores: [],
      exibirLegenda: false,
      chartFaturamentoPrecoMedioClassificacaoVendedores: {},
      coresPrecoMedioClassificacaoVendedores: [],
      chartFaturamentoMetaVendedorClassificacao: {},
      coresMetaVendedorClassificacao: [
        { status: 'Vlr Fat', cor: '#00897B' },
        { status: 'Vlr Meta', cor: '#C62828' },
      ],
      valorKgFaturamento: parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'kg',
      coresDevolucaoxOrcadoVendedores: [
        { status: '% Orçado Devolução', cor: '#00897B' },
        { status: '% Devolução', cor: '#C62828' },
      ],
      dynamicPaddingAnaliseVendedor1: '',
      dynamicPaddingAnaliseVendedor2: '',
      dynamicPaddingAnaliseVendedor3: '',
      dynamicPaddingAnaliseVendedor4: '',
      loadingMetaVendedor: false,
      loadingPrecoMedioVendedor: false,
      loadingKgFaturamento: false,
      loadingDevolucaoOrcadoVendedor: false,
      loadingKgTotalVendedor: false,
      imprimindo: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    created () {
      eventEmit.$on('update-dados-filtros', this.handleUpdateDados)

      eventEmit.$on('enable-btn-print', this.handleBtnPrint)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-filtros', this.handleUpdateDados)

      eventEmit.$off('enable-btn-print', this.handleBtnPrint)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Análise Vendedor')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingAnaliseVendedor1 = 'padding-right: 15rem !important'

          this.dynamicPaddingAnaliseVendedor2 = 'padding-right: 40rem !important'

          this.dynamicPaddingAnaliseVendedor3 = 'padding-right: 11rem !important'

          this.dynamicPaddingAnaliseVendedor4 = 'padding-right: 14rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingAnaliseVendedor1 = 'padding-right: 10rem !important'

          this.dynamicPaddingAnaliseVendedor2 = 'padding-right: 29rem !important'

          this.dynamicPaddingAnaliseVendedor3 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseVendedor4 = 'padding-right: 10rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingAnaliseVendedor1 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseVendedor2 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseVendedor3 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseVendedor4 = 'padding-right: 6rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingAnaliseVendedor1 = 'padding-right: 25rem !important'

          this.dynamicPaddingAnaliseVendedor2 = 'padding-right: 25rem !important'

          this.dynamicPaddingAnaliseVendedor3 = 'padding-right: 25rem !important'

          this.dynamicPaddingAnaliseVendedor4 = 'padding-right: 25rem !important'
        } else {
          this.dynamicPaddingAnaliseVendedor1 = 'padding-right: 6rem !important'

          this.dynamicPaddingAnaliseVendedor2 = 'padding-right: 20rem !important;'

          this.dynamicPaddingAnaliseVendedor3 = 'padding-right: 8rem !important; margin: -1rem 0 0 -1rem'

          this.dynamicPaddingAnaliseVendedor4 = 'padding-right: 6rem !important'
        }
      },

      handleUpdateDados (vendedor, redes, mes, ano, supervisor) {
        this.vendedor = vendedor
        this.redes = redes
        this.mes = mes
        this.ano = ano
        this.supervisor = supervisor

        this.updateDate()
      },

      updateDate () {
        eventEmit.$emit('set-update-filtros', this.vendedor, this.redes, this.mes, this.ano, this.supervisor)

        this.enableBtnPrint = false

        this.atualizaGrafico()
      },

      handleBtnPrint () {
        this.enableBtnPrint = true
      },

      async atualizaGrafico () {
        this.loadingMetaVendedor = true
        this.loadingPrecoMedioVendedor = true
        this.loadingKgFaturamento = true
        this.loadingDevolucaoOrcadoVendedor = true
        this.loadingKgTotalVendedor = true

        this.valorKgFaturamento = parseFloat(0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'kg'

        if (this.chartFaturamentoPrecoMedioClassificacaoVendedores.data) {
          this.chartFaturamentoPrecoMedioClassificacaoVendedores.destroy()
        }

        if (this.chartFaturamentoMetaVendedorClassificacao.data) {
          this.chartFaturamentoMetaVendedorClassificacao.destroy()
        }

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        if (this.myChart2.data) {
          this.myChart2.destroy()
        }

        await Comercial.showGraficoFatPrecoMedioClassificacaoVendedores(this.vendedor, this.redes, this.mes, this.ano, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            for (var i = 0; i < resposta.data.cores.length; i++) {
              const cor = resposta.data.cores[i].cor

              this.coresPrecoMedioClassificacaoVendedores.push(cor)
            }

            const ctx = document.getElementById('myChartFaturamentoPrecoMedioClassificacaoVendedores').getContext('2d')

            const widthMobile = window.innerWidth

            var mobile = !(window.innerWidth < 600)

            this.chartFaturamentoPrecoMedioClassificacaoVendedores = new Chart(ctx, {
              plugins: widthMobile <= 768 ? null : [ChartDataLabels],
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    backgroundColor: this.coresPrecoMedioClassificacaoVendedores,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      return resposta.data.labels[tooltipItem[0].index]
                    },
                  },
                },
                plugins: {
                  datalabels: {
                    display: true,
                    color: function (context) {
                      return '#000000'
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    align: 'center',
                    anchor: 'end',
                    offset: 10,
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.msg === 'Data inicial nao pode ser maior que a data Final') {
            if (this.chartFaturamentoPrecoMedioClassificacaoVendedores.data) {
              this.chartFaturamentoPrecoMedioClassificacaoVendedores.destroy()
            }

            this.showSnackbar('error', 3000, e.data.msg)
          } else if (e.data.text === 'Empresa não encontrada') {
            if (this.chartFaturamentoPrecoMedioClassificacaoVendedores.data) {
              this.chartFaturamentoPrecoMedioClassificacaoVendedores.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          } else if (e.data.text === 'Nao há dados para montar ao gráfico') {
            if (this.chartFaturamentoPrecoMedioClassificacaoVendedores.data) {
              this.chartFaturamentoPrecoMedioClassificacaoVendedores.destroy()
            }

            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => { this.loadingPrecoMedioVendedor = false })

        await Comercial.showGraficoFaturamentoMetaVendedorClassificacao(this.vendedor, this.redes, this.mes, this.ano, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            var mobile = !(window.innerWidth < 600)

            const ctx = document.getElementById('myChartFaturamentoMetaVendedorClassificacao').getContext('2d')

            this.chartFaturamentoMetaVendedorClassificacao = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Meta',
                    data: resposta.data.meta,
                    backgroundColor: '#C62828',
                    order: 2,
                  },
                  {
                    label: 'Faturamento',
                    data: resposta.data.faturamento,
                    backgroundColor: '#00897B',
                    order: 1,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: mobile,
                    color: function (context) {
                      if (context.dataset.label !== 'Porcentagem') {
                        return '#000000'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 14,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    rotation: 270,
                    align: 'top',
                    anchor: 'start',
                    offset: 10,
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return tooltipItem[0].xLabel + ' - Meta'
                      } else {
                        return tooltipItem[0].xLabel + ' - Faturamento'
                      }
                    },
                  },
                  titleFontSize: 16,
                  bodyFontSize: 16,
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingMetaVendedor = false })

        await Comercial.showTotalKilosFaturadosVendedor(this.vendedor, this.redes, this.mes, this.ano, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.exibirKilo = true

            this.valorKgFaturamento = resposta.data.kilos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'kg'
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingKgFaturamento = false })

        await Comercial.showGraficoDevolucaoOrcadoClassificacaoVendedores(this.vendedor, this.redes, this.mes, this.ano, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.exibirLegenda = true

            const ctx = document.getElementById('myChartDevolucaoxOrcadoVendedores').getContext('2d')

            var mobile = !(window.innerWidth < 600)

            this.myChart = new Chart(ctx, {
              plugins: [ChartDataLabels],
              type: 'bar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: '% Devolução',
                    data: resposta.data.devolucao,
                    backgroundColor: '#C62828',
                    order: 2,
                  },
                  {
                    label: '% Orçado Devolução',
                    data: resposta.data.orcado,
                    backgroundColor: '#00897B',
                    order: 1,
                  },
                ],
              },
              options: {
                plugins: {
                  datalabels: {
                    display: mobile,
                    color: function (context) {
                      if (context.dataset.label !== 'Porcentagem') {
                        return '#000000'
                      } else {
                        return 'transparent'
                      }
                    },
                    font: {
                      size: 14,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
                    },
                    rotation: 270,
                    align: 'end',
                    offset: 4,
                  },
                },
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%'
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return tooltipItem[0].xLabel + ' - % Devolução'
                      } else {
                        return tooltipItem[0].xLabel + ' - % Orçado Devolução'
                      }
                    },
                  },
                  titleFontSize: 16,
                  bodyFontSize: 16,
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingDevolucaoOrcadoVendedor = false })

        await Comercial.showGraficoKgTotalClassificacaoVendedor(this.vendedor, this.redes, this.mes, this.ano, this.supervisor, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            for (var i = 0; i < resposta.data.cores.length; i++) {
              const cor = resposta.data.cores[i].cor

              this.cores.push(cor)
            }

            var mobile = !(window.innerWidth < 600)

            const ctx1 = document.getElementById('myChartKgTotalClassificacaoVendedor').getContext('2d')

            this.myChart2 = new Chart(ctx1, {
              plugins: [ChartDataLabels],
              type: 'horizontalBar',
              data: {
                labels: resposta.data.labels,
                datasets: [
                  {
                    label: 'Faturamento',
                    data: resposta.data.kilos,
                    backgroundColor: this.cores,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                  yAxes: [{
                    gridLines: {
                      display: false,
                    },
                    display: mobile,
                  }],
                },
                responsive: true,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      return data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'kg'
                    },
                    title: (tooltipItem) => {
                      return resposta.data.labels[tooltipItem[0].index]
                    },
                  },
                },
                plugins: {
                  datalabels: {
                    display: mobile,
                    color: function (context) {
                      return '#000000'
                    },
                    font: {
                      size: 11,
                    },
                    formatter: (value) => {
                      return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'kg'
                    },
                    align: 'end',
                    offset: 10,
                  },
                },
              },
            })
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error2 = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loadingKgTotalVendedor = false })
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Definir a margem esquerda
          const marginLeftRem = -1
          const marginLeftPx = marginLeftRem * 16
          let posYFiltros = 10

          const title = 'Análise Vendedor'
          pdf.text(title, 105, posYFiltros)

          posYFiltros += 10
          const filtros = 'Filtros Selecionados:'
          pdf.setFontSize(10)
          pdf.text(filtros, 15, posYFiltros)

          const datas = this.mes[0].texto + ' - ' + this.ano
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedor.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisor.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redes.map(r => r.rede))

          if (posYFiltros > 70) {
            pdf.addPage()

            posYFiltros = 10
          }

          // Adicionar a imagem dos filtros usando html2canvas
          const bloco1 = document.getElementById('bloco1Print')
          const canvasBloco1Print = await html2canvas(bloco1)
          const imgWidthBloco1 = 290
          const imgHeightBloco1 = (canvasBloco1Print.height * imgWidthBloco1) / canvasBloco1Print.width

          pdf.addImage(canvasBloco1Print.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthBloco1, imgHeightBloco1)

          posYFiltros += imgHeightBloco1

          pdf.addPage()
          posYFiltros = 10

          const bloco2 = document.getElementById('bloco2Print')
          const canvasBloco2Print = await html2canvas(bloco2)
          const imgWidthBloco2 = 290
          const imgHeightBloco2 = (canvasBloco2Print.height * imgWidthBloco2) / canvasBloco2Print.width

          pdf.addImage(canvasBloco2Print.toDataURL('image/png'), 'PNG', 20 + marginLeftPx, posYFiltros, imgWidthBloco2, imgHeightBloco2)

          pdf.save('relatorio_analise_vendedores.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.faturamentoGrupoProdutosPrint = []
          this.faturamentoLinhaPrint = []
          this.headersTableLinha = []
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }

</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {
    #textoFaturamento {
      margin: 0 0 0 -8rem;
    }

    #iconInformationFatVendedor {
      margin: -6.8rem 0 0 0;
    }

    #textoPrecoMedioVendedor {
      margin: 0 0 0 -3rem;
    }

    #iconInformationFatMetaVendedor {
      margin: -6.8rem 0 0 0;
    }

    #textoClassificacao {
      margin: 0 0 0 -9rem;
    }

    #iconInformationPrecoMedioVendedor {
      margin: -6.8rem 0 0 0;
    }

    #textoDevolucaoImpropria {
      margin: 2rem 0 0 -7.2rem
    }

    #textoKgTotalVendedorId {
      margin: 0 0 0 -8rem;
    }

    #iconInformationKgTotalFat {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationDevolucaoImpropria {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationDevOrcadoVendedor {
      margin: -6.8rem 0 0 0;
    }

    #iconInformationKgTotalVendedor {
      margin: -6.8rem 0 0 0;
    }

    /* #myChartDevolucaoxOrcadoVendedores {
      width: 405px !important;
      height: 213px !important;
    } */

    /* #myChartKgTotalClassificacaoVendedor {
      width: 378px !important;
      height: 214px !important;
      margin: -3rem 0 0 0;
    } */
  }

  @media screen
  and (min-width : 601px)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
    /* #myChartDevolucaoxOrcadoVendedores {
      width: 856px !important;
      height: 420px !important;
    } */

    /* #myChartKgTotalClassificacaoVendedor {
      width: 856px !important;
      height: 420px !important;
    } */
  }

  @media screen
  and (min-width: 1380px) {
    /* #myChartKgTotalClassificacaoVendedor {
      margin: 4rem 0 0 -2rem;
      width: 429px !important;
      height: 214px !important;
    } */

    /* #myChartDevolucaoxOrcadoVendedores {
      width: 883px !important;
      height: 441px !important;
    } */
  }
</style>

<style lang="sass">
  #textoAnaliseFaturamento
    font-size: 36px
    margin: 1.5rem 0 0 0

  #textoFaturamento
    margin: 0 0 0 -2rem

  #btnPrint
    margin: 0.5rem 0 2rem 3rem

  #myChartDevolucaoxOrcadoVendedores
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    // width: 512px !important
    // height: 256px !important

  #myChartKgTotalClassificacaoVendedor
    font-size: 20px
    display: grid
    align-items: center
    font-weight: bold
    margin: 1rem 0 0 1rem
    width: 390px !important
    height: 270px !important

  #textoDevolucaoImpropria
    margin: 2rem 0 0 0

  #iconInformationDevolucaoImpropria
    margin: 2rem 0 0 0

  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemFaturamento
    padding-right: 17rem !important
    margin: -2rem 0 0 -1rem

  #listItemFaturamentoClassificacao
    padding-right: 39rem !important
    margin: -2rem 0 0 -1rem

  #listItemFaturamentoPrecoMedioClassificacao
    padding-right: 9rem !important
    margin: -2rem 0 0 -1rem

  #listItemDevolucaoVendedores
    padding-right: 14rem !important
    margin: -2rem 0 0 -1rem

  #componenteDevolucaoImpropriaVendedor
    margin: -4rem 0 0 7rem
</style>
